import { importDataDictionary } from "constants/importDataDict";

export function fileWeightValidator(file: File, maxSize: number = 5000000) {
    if (file?.size > maxSize) {
        return {
            code: "weight-too-large",
            message: `${file.size} is larger than 5mb`,
        };
    }
    return null;
}

export const objectOmitKeysFn = (keys: string[], obj: Record<string, any>): Record<string, any> => {
    if (!keys.length) return obj;

    return keys.reduce((acc, keyToOmit) => {
        const { [keyToOmit]: omitted, ...restObj } = acc;
        return restObj;
    }, obj);
};

export const objectKeepKeysFn = (keys: string[], obj: Record<string, any>): Record<string, any> => {
    if (!keys.length) return obj;

    return keys.reduce((acc, keyToKeep) => {
        return {
            ...acc,
            ...(Object.hasOwn(obj, keyToKeep) ? { [keyToKeep]: obj[keyToKeep] } : {}),
        };
    }, {});
};

export const objectOmitEmptyValuesFn = (obj: Record<string, any>): Record<string, any> => {
    return Object.keys(obj).reduce((acc, key) => {
        const value = ((v) => {
            if (typeof v === "string" || v instanceof String) {
                return v.trim();
            }
            return v;
        })(obj[key]);

        if (value) {
            return {
                ...acc,
                [key]: value,
            };
        }
        return acc;
    }, {});
};

const escapeCsvCell = (value: string): string => {
    if (/[",\n\r]/.test(value)) {
        return `"${value.replace(/"/g, '""')}"`;
    }
    return value;
};

export const createEncodedCSVString = (arrayOfData: Array<Array<string>>): string => {
    const csvContent =
        "data:text/csv;charset=utf-8,\uFEFF" + arrayOfData.map((row) => row.map(escapeCsvCell).join(",")).join("\n");
    return encodeURI(csvContent);
};
